import { useTranslation } from 'react-i18next';
import { Box, Container, Grid, Stack, Text, Title } from '@mantine/core';
import DealExample from '@/components/landing/DealExample';
import LandingSectionLabel from '@/components/landing/LandingSectionLabel';

const SCENARIOS = ['sell', 'buy'] as const;

// «Как это работает»: два сценария (продавец и покупатель) и условный пример сделки с этапами. Здесь звучит главное
// обещание продукта: логистику считает платформа, поэтому обе стороны заранее знают свои деньги.
export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <Container id="how" size="lg" py={{ base: 'xl', md: 48 }}>
      <Grid gap={{ base: 'lg', md: 'xl' }} align="flex-start">
        <Grid.Col span={{ base: 12, md: 5 }}>
          <Stack gap="lg">
            <Stack gap="md">
              <LandingSectionLabel>{t('landing.how.label')}</LandingSectionLabel>
              <Title order={2} fz={{ base: 26, sm: 30 }}>
                {t('landing.how.title')}
              </Title>
            </Stack>
            {SCENARIOS.map((key) => (
              <Box key={key}>
                <Title order={3} fz="lg" mb={4}>
                  {t(`landing.how.${key}.title`)}
                </Title>
                <Text>{t(`landing.how.${key}.text`)}</Text>
              </Box>
            ))}
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 7 }}>
          <DealExample />
        </Grid.Col>
      </Grid>
    </Container>
  );
}
